import { useFetchEqlFieldValues } from '@modules/common/hooks';
import { Box, Skeleton, Typography } from '@mui/material';

interface MetadataSampleValueProps {
  metadataKey: string;
}

const MAX_VALUES_TO_SHOW = 3;

export const MetadataSampleValue = ({
  metadataKey,
}: MetadataSampleValueProps) => {
  const [, { values: eqlFieldValues, isLoading }] = useFetchEqlFieldValues({
    eqlField: metadataKey,
    fetchPolicy: 'cache-and-network',
    limit: MAX_VALUES_TO_SHOW,
  });

  if (isLoading) {
    return <Skeleton variant="text" width={100} height={10} />;
  }

  return (
    <Box width="100%">
      {eqlFieldValues
        .slice(0, MAX_VALUES_TO_SHOW) // TODO: We can remove this once BE fixes the `limit` param
        .map((eqlFieldValue, index) => (
          <Typography variant="caption" key={eqlFieldValue.value}>
            {eqlFieldValue.displayName}
            {index < MAX_VALUES_TO_SHOW - 1 ? ', ' : ''}
          </Typography>
        ))}{' '}
    </Box>
  );
};
